// Application Keys
export const TGA_VARIETIES_APPLICATION_KEY = 'TGA varieties';
export const USER_NOTIFICATIONS_APPLICATION_KEY = 'UserNotifications';
export const BALANS_BEMESTING_CROP_FIELDS_ADMIN_APPLICATION_KEY = 'Balans Bemesting Crop Fields Admin';
export const WATER_AUTHORITIES_APPLICATION_KEY = 'FieldAdviceAdmin';
export const SPRAY_COCKTAILS_APPLICATION_KEY = 'Admin Spray Cocktails';
export const CROP_AID_SYNERGIES_APPLICATION_KEY = 'FieldAdviceAdmin';
export const CROP_AID_ADMIN_APPLICATION_KEY = 'FieldAdviceAdmin';
export const CROP_AID_ADMISSION_APPLICATION_KEY = 'CropAidAdmission';
export const BLIGHT_INFECTION_APPLICATION_KEY = 'ArableDiseaseAdmin';
export const FIELD_REPORT_APPLICATION_KEY = 'FieldReport';
export const CROP_ADMIN_APPLICATION_KEY = 'CropAdmin';
export const ARABLE_PERIOD_APPLICATION_KEY = 'ArablePeriod';
export const PLANET_PROOF_APPLICATION_KEY = 'PlanetProof';
export const FIELD_ADVICE_ADMIN_APPLICATION_KEY = 'FieldAdviceAdmin';
